/* import React, { Fragment } from 'react';
import { appRoutes } from './appRoutes';
import { Route, Routes } from 'react-router-dom';

function ApplicationRouter() {
  return (
    <Routes>
      {appRoutes.map(({ Component, children }, key) => (
        <Route exact element={<Component />} key={key}>
          {children.map(({ path, Component }, key) => (
            <Route path={path} element={<Component />} key={key} />
          ))}
        </Route>
      ))}
    </Routes>
  );
}

export default ApplicationRouter;
 */

import React from 'react';
import { appRoutes } from './appRoutes';
import { Route, Routes } from 'react-router-dom';

/**
 * A recursive function to render routes, including nested layouts.
 */
function renderRoutes(routes) {
  return routes.map(({ Component, path, children }, key) => {
    if (children) {
      // If children exist, render recursively
      return (
        <Route path={path} element={<Component />} key={key}>
          {Array.isArray(children)
            ? renderRoutes(children) // Recursively render nested routes
            : children.Component && (
                <Route element={<children.Component />}>
                  {renderRoutes(children.children || [])}
                </Route>
              )}
        </Route>
      );
    }
    // Leaf route
    return <Route path={path} element={<Component />} key={key} />;
  });
}

function ApplicationRouter() {
  return <Routes>{renderRoutes(appRoutes)}</Routes>;
}

export default ApplicationRouter;
